import OwaTxpStyle from '../../store/viewSchema/OwaTxpStyle';
import { mergeStyles } from '@uifabric/merge-styles';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { isBrowserFirefox, isBrowserIE } from 'owa-user-agent/lib/userAgent';

let classNames = require('classnames');
const isIEFirefox = isBrowserFirefox() || isBrowserIE();

/**
 *  This function returns the OwaTxpStyle object for Mail cards
 */
export function createMailCardStyle(styles: any): OwaTxpStyle {
    let txpStyle: OwaTxpStyle = {};
    if (styles) {
        txpStyle = {
            cardSummaryContainer: styles.txpCardSummary,
            cardSummaryLines: styles.summaryLines,
            planeStyle: styles.plane,
            summaryLabel: styles.summaryLabel,
            editableSummaryLabel: isIEFirefox
                ? styles.editableSummaryLabelIEFF
                : styles.editableSummaryLabel,
            editableDetailsLabel: styles.editableDetailsLabel,
            detailsLabel: styles.detailsLabel,
            imageClassName: styles.imageMail,
            actionButtonsContainer: styles.containerButtonsMail,
            cardContainer: styles.horizontalExpandedCard,
            flight: styles.flightsMail,
            reservationStatus: styles.reservationStatusContainerMail,
            cardDetailsDataRow: styles.detailsDataRowMail,
            labelStyle: styles.labelStyleMail,
            iconStyle: styles.iconStyleMail,
        };
    }

    return txpStyle;
}

/**
 *  This function returns the OwaTxpStyle object for Calendar Peek
 */
export function createCalendarPeekStyle(colorScheme: ColorScheme, styles: any): OwaTxpStyle {
    let txpStyle: OwaTxpStyle = {};
    if (styles) {
        txpStyle = {
            txpColor: colorScheme,
            primaryColor: colorScheme.calPrimary,
            lighterAltColor: colorScheme.calLighterAlt,
            lighterColor: colorScheme.calLighter,
            lightColor: colorScheme.calLight,
            darkColor: colorScheme.calDark,
            darkerColor: colorScheme.calDarker,
            cardSummaryContainer: styles.txpPeekCardSummary,
            cardSummaryLines: styles.PeekCardSummaryLines,
            planeStyle: styles.peekPlane,
            summaryLabel: classNames(
                isIEFirefox ? styles.summaryLabelPeekIEFF : styles.summaryLabelPeek,
                mergeStyles({
                    selectors: {
                        ':first-child': { color: colorScheme.calPrimary },
                    },
                })
            ),
            detailsLabel: styles.detailsLabelPeek,
            imageClassName: classNames(
                styles.imageCalendarPeek,
                mergeStyles({ background: colorScheme.calPrimary })
            ),
            actionButtonsContainer: styles.containerButtonsPeek,
            flightDetails: styles.peekFlightDetails,
            flightTerminalGate: styles.peekFlightTerminalGate,
            cardContainer: styles.calendarPeekCard,
            flight: styles.flightsPeek,
            reservationStatus: styles.reservationStatusContainerPeek,
            cardDetailsDataRow: styles.detailsDataRowPeek,
            locationRowStyle: styles.calendarPeekLocationStyle,
            labelStyle: styles.labelStylePeek,
            iconStyle: styles.iconStyleCalendar,
        };
    }

    return txpStyle;
}

/**
 *  This function returns the OwaTxpStyle object for Calendar read form
 */
export function createCalendarFormStyle(colorScheme: ColorScheme, styles: any): OwaTxpStyle {
    let txpStyle: OwaTxpStyle = {};
    if (styles) {
        txpStyle = {
            txpColor: colorScheme,
            primaryColor: colorScheme.calPrimary,
            lighterAltColor: colorScheme.calLighterAlt,
            cardSummaryContainer: styles.txpPeekCardSummary,
            cardSummaryLines: styles.calendarFormSummaryLines,
            planeStyle: styles.peekPlane,
            summaryLabel: styles.calendarFormSummaryLabel,
            detailsLabel: styles.detailsLabelPeek,
            actionButtonsContainer: styles.containerButtons,
            flightDetails: styles.calendarFormFlightDetails,
            flightTerminalGate: styles.calendarFormFlightTerminalGate,
            cardContainer: styles.calendarFormCard,
            cardDetailsContainer: styles.calendarFormDetailsContainer,
            cardDetailsDataRow: styles.detailsDataRowForm,
            reservationStatus: styles.reservationStatusContainerPeek,
            imageClassName: styles.calendarFormImageClassName,
            labelStyle: styles.labelStyleForm,
            iconStyle: styles.iconStyleCalendar,
        };
    }

    return txpStyle;
}
